module.exports = __webpack_public_path__ + "img/empty_basket.3e1727ce.png";